import { render, staticRenderFns } from "./UiChartBar.vue?vue&type=template&id=fec0e1dc"
import script from "./UiChartBar.vue?vue&type=script&lang=js"
export * from "./UiChartBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports